import { render, staticRenderFns } from "./ProfessionalBody.vue?vue&type=template&id=6dfa833e&scoped=true"
import script from "./ProfessionalBody.vue?vue&type=script&lang=js"
export * from "./ProfessionalBody.vue?vue&type=script&lang=js"
import style0 from "./ProfessionalBody.vue?vue&type=style&index=0&id=6dfa833e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfa833e",
  null
  
)

export default component.exports